import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * External dependencies
 */
import { v4 as uuid } from 'uuid';
/**
 * WordPress dependencies
 */

import { Component } from '@wordpress/element';
import { createHigherOrderComponent } from '@wordpress/compose';
/**
 * Internal dependencies
 */

import NoticeList from '../../notice/list';
/**
 * Override the default edit UI to include notices if supported.
 *
 * @param  {WPComponent} OriginalComponent Original component.
 *
 * @return {WPComponent} Wrapped component.
 */

export default createHigherOrderComponent(function (OriginalComponent) {
  return /*#__PURE__*/function (_Component) {
    _inherits(WrappedBlockEdit, _Component);

    var _super = _createSuper(WrappedBlockEdit);

    function WrappedBlockEdit() {
      var _this;

      _classCallCheck(this, WrappedBlockEdit);

      _this = _super.apply(this, arguments);
      _this.createNotice = _this.createNotice.bind(_assertThisInitialized(_this));
      _this.createErrorNotice = _this.createErrorNotice.bind(_assertThisInitialized(_this));
      _this.removeNotice = _this.removeNotice.bind(_assertThisInitialized(_this));
      _this.removeAllNotices = _this.removeAllNotices.bind(_assertThisInitialized(_this));
      _this.state = {
        noticeList: []
      };
      _this.noticeOperations = {
        createNotice: _this.createNotice,
        createErrorNotice: _this.createErrorNotice,
        removeAllNotices: _this.removeAllNotices,
        removeNotice: _this.removeNotice
      };
      return _this;
    }
    /**
     * Function passed down as a prop that adds a new notice.
     *
     * @param {Object} notice  Notice to add.
     */


    _createClass(WrappedBlockEdit, [{
      key: "createNotice",
      value: function createNotice(notice) {
        var noticeToAdd = notice.id ? notice : _objectSpread(_objectSpread({}, notice), {}, {
          id: uuid()
        });
        this.setState(function (state) {
          return {
            noticeList: [].concat(_toConsumableArray(state.noticeList), [noticeToAdd])
          };
        });
      }
      /**
       * Function passed as a prop that adds a new error notice.
       *
       * @param {string} msg  Error message of the notice.
       */

    }, {
      key: "createErrorNotice",
      value: function createErrorNotice(msg) {
        this.createNotice({
          status: 'error',
          content: msg
        });
      }
      /**
       * Removes a notice by id.
       *
       * @param {string} id  Id of the notice to remove.
       */

    }, {
      key: "removeNotice",
      value: function removeNotice(id) {
        this.setState(function (state) {
          return {
            noticeList: state.noticeList.filter(function (notice) {
              return notice.id !== id;
            })
          };
        });
      }
      /**
       * Removes all notices
       */

    }, {
      key: "removeAllNotices",
      value: function removeAllNotices() {
        this.setState({
          noticeList: []
        });
      }
    }, {
      key: "render",
      value: function render() {
        return createElement(OriginalComponent, _extends({
          noticeList: this.state.noticeList,
          noticeOperations: this.noticeOperations,
          noticeUI: this.state.noticeList.length > 0 && createElement(NoticeList, {
            className: "components-with-notices-ui",
            notices: this.state.noticeList,
            onRemove: this.removeNotice
          })
        }, this.props));
      }
    }]);

    return WrappedBlockEdit;
  }(Component);
});
//# sourceMappingURL=index.js.map